import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { getBikeCategory } from '@/utils/utils'
import BikeSetup from '@/components/preview/common/BikeSetup.vue'
import { BfLoader } from '@finetic/bikefitting-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikeSetupStart',
  setup(__props) {

const bikeStore = useBikeStore()
const { bikeData, bikeSetup } = storeToRefs(bikeStore)

return (_ctx: any,_cache: any) => {
  return (_unref(bikeData) && _unref(bikeSetup))
    ? (_openBlock(), _createBlock(BikeSetup, {
        key: 0,
        "hide-delta": true,
        "hide-stack-reach": true,
        "bike-category": 
      _unref(getBikeCategory)(_unref(bikeData)?.MAIN_BIKETYPE_NAME, _unref(bikeData)?.SUB_BIKETYPE_NAME)
    ,
        "crank-arm-length": _unref(bikeData)?.CRANK_LENGTH,
        "pedal-height": _unref(bikeData)?.PEDAL_HEIGHT,
        "saddle-handlebar-drop": _unref(bikeSetup)?.SADDLE_HANDLEBAR_DROP,
        "saddle-height": _unref(bikeSetup)?.SADDLE_HEIGHT,
        "saddle-to-handlebar": _unref(bikeSetup)?.SADDLE_HANDLEBAR_DISTANCE,
        "saddle-width": 80
      }, null, 8, ["bike-category", "crank-arm-length", "pedal-height", "saddle-handlebar-drop", "saddle-height", "saddle-to-handlebar"]))
    : (_openBlock(), _createBlock(_unref(BfLoader), { key: 1 }))
}
}

})